import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function InfoEstudiante({ data }) {
  const desktop = useMediaQuery("(min-width: 1000px)");

  return (
    <Stack
      sx={{
        flexDirection: "row",
        marginY: 3.5,
        gap: 7,
        ...(desktop && {
          marginTop: 8,
          marginBottom: 8,
        }),
      }}
    >
      <Box
        sx={{
          marginTop: "10px",
          width: "2.5px",
          height: "85%",
          bgcolor: "#B71234",
        }}
      />
      <Stack
        sx={{
          gap: "15px",
          ...(desktop && {
            gap: "23px",
          }),
        }}
      >
        {Object.entries(data).map(([key, value]) => (
          <>
            <Stack
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: "30px",
                marginLeft: "-64px",
              }}
            >
              <div
                style={{
                  width: "13px",
                  height: "13px",
                  borderRadius: "50%",
                  backgroundColor: "#B71234",
                }}
              ></div>
              <Typography
                sx={{
                  fontSize: "18px",
                  paddingLeft: "5px",
                }}
              >
                {key}
              </Typography>
            </Stack>
            <Typography
              sx={{
                width: "225px",
                fontWeight: "bold",
                fontSize: "20px",
                marginLeft: "-15px",
                marginTop: "-17.5px",
              }}
            >
              {value}
            </Typography>
          </>
        ))}
      </Stack>
    </Stack>
  );
}
